import styled from "styled-components"

export const Main = styled.div`
    margin: 0;
    background-color: var(--main-bg-color);
    min-height: 100vh;
`